import { setErrorMessage, clearErrorMessage } from './actions';
const initialState = null;
function errorReducer(state = initialState, action) {
    switch (action.type) {
        case setErrorMessage.toString():
            return action.payload;
        case clearErrorMessage.toString():
            return initialState;
        default:
            return state;
    }
}
export default errorReducer;
